import React from 'react';
import {
	AREA_OPTIONS_BY_DOMAIN,
	RequestHistoryDomain,
	USED_IN_OPTIONS,
} from '../lib/request-history';

export const UsedInAreaFilters = ({
	requestHistory,
	onRequestHistoryChange,
	translationType,
	onTranslationTypeChange,
	extraAreaOptions,
}: {
	requestHistory: RequestHistoryDomain | '';
	onRequestHistoryChange: (requestHistory: RequestHistoryDomain | '') => void;
	translationType: string;
	onTranslationTypeChange: (translationType: string) => void;
	// areas listed ahead of the domain's own ones (e.g. the lookup tab's combined areas)
	extraAreaOptions?: Record<RequestHistoryDomain, { value: string; label: string }[]>;
}) => {
	return (
		<>
			<label className="search-filter-label">
				Used In
				<select
					className="search-filter-select"
					value={requestHistory}
					onChange={(e) => {
						onRequestHistoryChange(e.target.value as RequestHistoryDomain | '');
						onTranslationTypeChange('');
					}}
				>
					<option value="">Please Select</option>
					{USED_IN_OPTIONS.map(({ value, label }) => (
						<option key={value} value={value}>
							{label}
						</option>
					))}
				</select>
			</label>
			{requestHistory && (
				<label className="search-filter-label">
					Area
					<select
						className="search-filter-select"
						value={translationType}
						onChange={(e) => {
							onTranslationTypeChange(e.target.value);
						}}
					>
						<option value="">Please Select</option>
						{[...(extraAreaOptions?.[requestHistory] ?? []), ...AREA_OPTIONS_BY_DOMAIN[requestHistory]].map(({ value, label }) => (
							<option key={value} value={value}>
								{label}
							</option>
						))}
					</select>
				</label>
			)}
		</>
	);
};
